/**
 * Created by liuhuijuan on 15/8/31.
 */
import {polyfill} from 'es6-promise';
import 'isomorphic-fetch';
var URLSearchParams = require('url-search-params');
import {getGuid, isObj, isEmptyObject, serialize, isArray, getOfflineTrans, handleErrorTrans } from './util'


//请求接口
function callFetch(url, method, params, headers, mode, dataType, mark, guid, analysisData) {
  var fullUrl = url;
  var data = {};
	var defaultHeaders = {
    'Accept': 'application/json, application/xml, text/play, text/html, *.*',
    'Content-Type': 'application/json; charset=utf-8',
    'EagleEye-TraceID': guid,
    'X-Sourced-By': 'ajax'
  };

  if (analysisData) {
    const { loginUserInfo = {Id: 0}, tenantInfo = {Id: 0}} = BSGlobal || {}
    const uid = loginUserInfo.Id && typeof (loginUserInfo.Id) !== 'string' ? loginUserInfo.Id : 0;
    const tid = tenantInfo.Id &&  typeof (tenantInfo.Id) !== 'string' ? tenantInfo.Id : 0;
    const { 
      sourceActionName: fal = '',  // 中文描述即来源动作名称
      sourceActionCode: fan = '', // 按钮编码
      pages,     // 页面名称
      pageCode: fpn = ''    // 页面编码
    } = analysisData || {};

    defaultHeaders = Object.assign({}, defaultHeaders, {
      'ftc': guid,
      fal: encodeURIComponent(fal),
      fpl: encodeURIComponent(pages),
      fan: encodeURIComponent(fan),
      fpn: encodeURIComponent(fpn),
      'user_id': uid,
      'tenant_id': tid,
      fapp: BSGlobal && BSGlobal.application || '',
      fver: BSGlobal && BSGlobal.appVersion || ''
    })
  }
  if (method.toUpperCase() == "GET" && params) {
    var conParam = fullUrl.indexOf("?") != -1 ? '&' : '?';
    fullUrl = fullUrl + conParam + serialize(params) + '&time='+(new Date().valueOf()); //拼接get请求
  } else if (headers && headers['Content-Type'] == 'application/x-www-form-urlencoded') {
    var urlSear = new URLSearchParams();
    for(var i in params) {  
      urlSear.append(i, params[i]);
    }
    data.body = urlSear.toString();
    data.method = method;
  } else {
    data.body = JSON.stringify(params);
    data.method = method;
  }
  //统一给url上新增参数：get和post请求
  var shadowContextStr = sessionStorage.getItem('shadow_context');
  var _pt = sessionStorage.getItem('_pt');
  var _ptid = sessionStorage.getItem('_ptid');

  var isWinParam = false;
  if (window.customParam && isObj(window.customParam) && !isEmptyObject(window.customParam)) {
    var joinParam = fullUrl.indexOf("?") != -1 ? '&' : '?';
    fullUrl = fullUrl + joinParam + serialize(window.customParam);
    isWinParam = true;
  } 
  
  if (!isWinParam && shadowContextStr) {
    var joinShadow = fullUrl.indexOf("?") != -1 ? '&' : '?';
    fullUrl = fullUrl + joinShadow + 'shadow_context='+ shadowContextStr;
  }
  if (!isWinParam && _pt && _ptid ) {
    var joinPt = fullUrl.indexOf("?") != -1 ? '&' : '?';
    fullUrl = fullUrl + joinPt + '_pt=' + _pt + '&_ptid=' + _ptid;
  }

  var newHeaders ;
  if (window.customHeaders && typeof window.customHeaders == 'function') {
    newHeaders = Object.assign({}, defaultHeaders, window.customHeaders());
  }else{
    newHeaders = Object.assign({}, defaultHeaders, headers);
  }
  data.headers = newHeaders
  data.credentials = 'include'; //传递cookie信息
  // data.mode = mode || null;

  //兼容公式编辑器的跨域请求，日后扩展加白名单
  if (/comput[eing]{1,3}(\-api)*?\.italent(\-inc)*?\.(link|cn)\/api\//.test(fullUrl)) {
    data.headers = headers;
    data.credentials = 'omit';
  } 
  
  //兼容safari&chrome url二次编码
  if(navigator.userAgent.indexOf("Safari") != -1) {
    fullUrl = fullUrl.replace(/%25/g, '%');
  }

  if (dataType && dataType == 'text') {
    return fetch(fullUrl, data).then(function(response) {
      return response.text().then(function(json){
        if (!response.ok) {
          return Promise.reject({status: response.status, json: json});
        }
        return {status: response.status};
      })
    })
  } 

  return fetch(fullUrl, data).then(response => {

    if (!response.ok) {
      response.json = function() {
        return this.text().then(function(data) {
          try {
              return JSON.parse(data);
          } catch(e) {
              return Promise.reject(response);
          }
        })
      }
    }
          
    return (
      response.json().then(json => ({ json, response })))
      }).then(({ json, response }) => {

      if (!response.ok) {
        return Promise.reject({json, response});
      }

      if (isArray(json)) {
        return json.slice();
      } else {
        return Object.assign({}, json);
      }
  });
}

//CALL_FETCH  无实际意义 防止用户写错
export const CALL_FETCH = Symbol('call API');

export default (config = {}) => store => next => action => {
  const callFETCH = action[CALL_FETCH];

  if (typeof callFETCH === 'undefined') {
    return next(action);
  }

  const {batch, types} = callFETCH;
  let nextActions;
  let batchArr = [];

  const dispatch = store.dispatch;
  let requestType, successType, failureType;

  if (Array.isArray(types) && types.length == 3) {
    requestType = types[0];
    successType = types[1];
    failureType = types[2];
  } else if (typeof types === 'string') {
    requestType = types + '_REQUEST';
    successType = types + '_SUCCESS';
    failureType = types + '_FAILURE';
  } else {
    throw new Error('Expected action types to be strings.');
  }

  function actionWith(data) {
    const finalAction = Object.assign({}, action, data);
    delete finalAction[CALL_FETCH];
    return finalAction;
  }
  
  next(actionWith({ type: requestType }));

  if (batch) {
    nextActions = batch.nextActions || undefined;
    for (var unity of batch){
      let {url, method} = unity;
      const {params, headers, mode, dataType, mark} = unity;
      method = method || "POST";

      if (typeof url === 'function') {
        url = url(store.getState());
      }
      if (typeof url !== 'string') {
        throw new Error('Specify a string endpoint URL.');
      }
      batchArr.push(callFetch(url, method, params, headers, mode, dataType, mark));
    }  
    return Promise.all(batchArr).then(
      response => {
        if (nextActions) fireNextAction(nextActions, dispatch, response);
        if (!isArray(response)) response = [];

        next(actionWith({
          response,
          type: successType,
          batch: batch,
          payload:'Injection'
        }));
      },
      error => {
        if (error.response) {
          var errorData = error.response;
          for (let key in error.json) {
            errorData[key] = error.json[key];
          }
        } else {
          var errorData = error;
        }
        next(actionWith({
          type: failureType,
          error: errorData,
          payload:'Injection'
        }));
      }
    );  
  } else {
    nextActions = callFETCH.nextActions || undefined;
    const { url, params, method, headers, mode, dataType, mark, analysisData } = callFETCH;
    let guid = getGuid();  //标识每个接口的guid
    return callFetch(url, method, params, headers, mode, dataType, mark, guid, analysisData).then(
      response => {
        if(nextActions) fireNextAction(nextActions, dispatch, response);
        next(actionWith({
          response,
          type: successType,
          url: url,
          params: params,
          method: method,
          mark: mark,
          guid: guid,
          payload:'Injection'
        }))
      },
      error => {
        // 新增断网提示
        if (navigator && !navigator.onLine) {
          error = {
            message: getOfflineTrans(),
            isOffLine: true
          }
        }
        var errorData;
        if (error.response) {
          errorData = error.response;
          for (var key in error.json) {
            errorData[key] = error.json[key]
          }
        } else {
          errorData = error;
        }
        if (errorData && errorData.message == 'Failed to fetch') {
          errorData.message = handleErrorTrans()
        }
        next(actionWith({
          type: failureType,
          error: errorData,
          guid: guid,
          payload:'Injection'
        }));
           
        return next(actionWith({
          type: "PROCESS_HTTP_CODE",
          error: errorData
         }));
      }
    );
  }   
};

//执行下一个action,并将数据传递给它
function fireNextAction(nextActions, dispatch, response) {
  if (nextActions && nextActions.length > 0 && dispatch) {
    nextActions.map(function(action, index, arr) {
      action({data: response});
    })
  }
}